import { CustomFieldType } from '__types__';
import {
  CircleAlert,
  Calendar,
  CalendarRange,
  CaseSensitive,
  Cloud,
  Coins,
  Hash,
  Link,
  ListCheck,
  ListChecks,
  Percent,
  Ruler,
  SquareCheck,
  type LucideIcon,
  type LucideProps
} from 'lucide-react';

/** What a custom field looks like by its type, wherever it is named (a filter, a column, a form unit). */
const CUSTOM_FIELD_TYPE_ICONS: Record<CustomFieldType, LucideIcon> = {
  [CustomFieldType.SHORT_TEXT]: CaseSensitive,
  [CustomFieldType.LONG_TEXT]: CaseSensitive,
  [CustomFieldType.URL]: Link,
  [CustomFieldType.NUMBER]: Hash,
  [CustomFieldType.PERCENTAGE]: Percent,
  [CustomFieldType.BOOLEAN]: SquareCheck,
  [CustomFieldType.DATE]: Calendar,
  [CustomFieldType.DATE_RANGE]: CalendarRange,
  [CustomFieldType.CURRENCY]: Coins,
  [CustomFieldType.MEASUREMENT]: Ruler,
  [CustomFieldType.MEASUREMENT_NEW]: Ruler,
  [CustomFieldType.DIMENSION_2D]: Ruler,
  [CustomFieldType.DIMENSION_3D]: Ruler,
  [CustomFieldType.HEIGHT]: Ruler,
  [CustomFieldType.SINGLE_SELECT]: ListCheck,
  [CustomFieldType.MULTI_SELECT]: ListChecks,
  [CustomFieldType.NETSUITE_MASTER_PROJECT]: Cloud,
  [CustomFieldType.NETSUITE_PO]: Cloud,
  [CustomFieldType.NETSUITE_VENDOR]: Cloud,
  [CustomFieldType.NETSUITE_SUBCLASS]: Cloud
};

/** The icon of a custom field's type. */
export function customFieldTypeIcon(type: CustomFieldType): LucideIcon {
  // A type the backend added before this map knows it.
  return CUSTOM_FIELD_TYPE_ICONS[type] ?? CircleAlert;
}

/** `customFieldTypeIcon` as a component. */
export function CustomFieldTypeIcon({
  type,
  ...props
}: LucideProps & { type: CustomFieldType }) {
  const Icon = customFieldTypeIcon(type);
  return <Icon {...props} />;
}
